module.exports = __webpack_public_path__ + "img/乌梢蛇.3f66e990.jpg";